/**
 * @fileoverview Admin Email Templates Page (MOR-716)
 *
 * Purpose: Edit the notification emails Morgan sends (task assigned, task
 * activity) with the embedded React Email editor.
 * URL: /admin/email-templates
 * Protection: super-admin — the underlying queries/mutations enforce the
 * role; the layout already gates /admin.
 */

import { createFileRoute } from "@tanstack/react-router";
import { EmailTemplateEditorPage } from "@/components/admin/email-templates/EmailTemplateEditorPage";

export const Route = createFileRoute(
  "/_app/_auth/admin/_layout/email-templates",
)({
  component: EmailTemplateEditorPage,
});
